import {Resource} from '@raison/types';
import React from 'react';
import {useSelector} from 'react-redux';
import {Navigate} from 'react-router';
import {useAppDispatch} from '~/shared/store';
import {CurrencyOptionProps, Layout, LayoutProps, LoadingScreen, Option} from './components';
import {CurrencyOptionView} from './interfaces';

export interface CurrencySelectionProps extends LayoutProps {
    selectOperations: (store: AppModel) => Resource<CurrencyOptionView[]>;
}

export function CurrencySelectionPage({selectOperations, ...props}: CurrencySelectionProps) {
    const futureOperations = useSelector(selectOperations);
    const dispatch = useAppDispatch();

    const withClickHandlers = (operations: CurrencyOptionView[]): CurrencyOptionProps[] =>
        operations.map(op => ({...op, onClick: () => dispatch(op.clickAction)}));

    if (!futureOperations.isSuccess) {
        return <LoadingScreen {...props} />;
    }
    const operations = futureOperations.data;
    if (operations.length === 0) {
        return <Navigate replace to='/assets' />;
    }

    return (
        <Layout {...props}>
            {withClickHandlers(operations).map((view, idx) => (
                <Option key={idx} {...view} />
            ))}
        </Layout>
    );
}
